import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f5f791b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cursor" }
const _hoisted_2 = { class: "background" }
const _hoisted_3 = { class: "icon" }

import { computed, ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useI18n } from 'vue-i18n';
import { gsap } from 'gsap'

import { useDoors, Temperature } from '@/services/stores/doors'
import { useAppState, useGameState } from '@/services/composition'
import useMousePosition from './useMousePosition'
import lerp from '@/utils/Lerp'

import UITemperatureIndicator from '@/components/UITemperatureIndicator/UITemperatureIndicator.vue'


enum Position {
  LEFT = 'left',
  RIGHT = 'right'
}

export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props

const state = useGameState()

const { t } = useI18n()
const { findDoor } = useDoors()



const root = ref(null)
const doorCheck = ref(null)

// const doorHovered = computed(() => {
//   return state.value.context.doorHovered !== -1
// })

const door = computed(() => {
  if ((!state.value.matches('game') && !state.value.matches('tuto'))) return null

  const id = state.value.context.doorHovered
  if (id === -1) return null

  const door = findDoor(id)
  return door
})

const doorTemperatureCheckClass = computed(() => {
  return ['door-temperature-check', `${door.value?.temperature}`, `door-temperature-check--${doorTemperatureCheckPosition.value}`]
})

const doorTemperatureText = computed(() => {
  return t(`game.temperature.${door.value?.temperature}`)
})

watch(door, () => {
  const $app = document.getElementById('app')
  if(door.value) {
    $app.style.cursor = 'pointer'
  } else {
    $app.style.removeProperty('cursor')
  }
})

const onEnter = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { scale: 0 }, { scale: 1, duration: 0.4 })
}

const onLeave = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { scale: 0, duration: 0.4 })
}

const inertia = 0.15
const { x: mouseX, y: mouseY } = useMousePosition()
const x = ref(mouseX.value)
const y = ref(mouseY.value)
const win = ref({ width: 0, height: 0 })
const doorTemperatureCheckPosition = ref(Position.RIGHT)
const doorCheckPosition = ref({ x: 0, y: 0 })
let rafId: number

const update = () => {
  x.value = lerp(x.value, mouseX.value, inertia)
  y.value = lerp(y.value, mouseY.value, inertia)

  gsap.set(root.value, { x: x.value, y: y.value })

  if (x.value >= win.value.width - 180) {
    doorCheckPosition.value.x = lerp(doorCheckPosition.value.x, -64, inertia * 0.5)
  } else {
    doorCheckPosition.value.x = lerp(doorCheckPosition.value.x, 64, inertia * 0.5)
  }
  if (y.value >= win.value.height - 180) {
    doorCheckPosition.value.y = lerp(doorCheckPosition.value.y, -96, inertia * 0.5)
  } else {
    doorCheckPosition.value.y = lerp(doorCheckPosition.value.y, 24, inertia * 0.5)
  }

  doorCheck.value && doorCheck.value.root && gsap.set(doorCheck.value.root, { x: doorCheckPosition.value.x, y: doorCheckPosition.value.y })

  rafId = requestAnimationFrame(update)
}

const resize = () => {
  win.value = {
    width: window.innerWidth,
    height: window.innerHeight,
  }
}

onMounted(async () => {
  await nextTick()
  window.addEventListener('resize', resize)
  resize()
  // setPosition = gsap.quickSetter(root.value, 'css')
  // gsap.ticker.add(update, false, true)
  rafId = requestAnimationFrame(update)
})

onUnmounted(() => {
  // gsap.ticker.remove(update)
  cancelAnimationFrame(rafId)
  window.removeEventListener('resize', resize)
})

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onLeave: onLeave,
    appear: ""
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        ref_key: "root",
        ref: root,
        class: "custom-cursor"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_Transition, {
            css: false,
            onEnter: onEnter,
            onLeave: onLeave
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("span", _hoisted_2, null, 512), [
                [_vShow, !_unref(door)]
              ])
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_ui_icon, { name: "cursor" })
          ])
        ]),
        _createVNode(_Transition, {
          css: false,
          onEnter: onEnter,
          onLeave: onLeave
        }, {
          default: _withCtx(() => [
            (_unref(door))
              ? (_openBlock(), _createBlock(UITemperatureIndicator, {
                  ref_key: "doorCheck",
                  ref: doorCheck,
                  key: _unref(door) && _unref(door).id,
                  text: _unref(doorTemperatureText),
                  class: _normalizeClass(_unref(doorTemperatureCheckClass))
                }, null, 8, ["text", "class"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, __props.show]
      ])
    ]),
    _: 1
  }))
}
}

})